import { SANDBOX_PRESET_TAG as T } from '../presetTags'
import { SANDBOX_PRESET_BODY_CSS, type SandboxComponentPreset } from '../../sandboxPresetTypes'

/**
 * Icon “morph” via **CSS transforms** on three bars (not SVG path morphing). `[aria-expanded="true"]` on the button
 * flips translations/rotations so bars form an X; `aria-label` updates for open vs close.
 */
const shell = SANDBOX_PRESET_BODY_CSS

const preset: SandboxComponentPreset = {
  id: 'svg-menu-morph',
  category: 'motion-svg',
  title: 'Menu → close morph',
  description: 'Three bars become an X with CSS transforms on a parent class.',
  tags: [T.svg, T.animation, T.button],
  html: `<h2>Toggle icon</h2>

<button type="button" id="tog" aria-expanded="false" aria-label="Open menu" class="icobtn">
  <span class="burger"><span class="b"></span><span class="b"></span><span class="b"></span></span>
</button>
<p id="st" class="small">State: menu</p>`,
  css: `${shell}

h2 {
  color: var(--nogrok-preview-primary);
  margin: 0 0 0.75rem;
}

.icobtn {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  border: 1px solid var(--nogrok-preview-outline);
  background: var(--nogrok-preview-surface-container);
  cursor: pointer;
  display: grid;
  place-items: center;
}

/* Three equal gaps between bars — transforms assume this geometry */
.burger {
  width: 22px;
  height: 16px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: transform 0.3s ease;
}

.burger .b {
  display: block;
  height: 2px;
  background: var(--nogrok-preview-primary);
  border-radius: 1px;
  transition: transform 0.3s ease, opacity 0.2s;
}

.icobtn[aria-expanded='true'] .burger {
  transform: rotate(90deg);
}

.icobtn[aria-expanded='true'] .b:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.icobtn[aria-expanded='true'] .b:nth-child(2) {
  opacity: 0;
}

.icobtn[aria-expanded='true'] .b:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

.small {
  margin-top: 1rem;
  font-size: 0.85rem;
}`,
  js: `const btn = document.getElementById('tog')
const st = document.getElementById('st')

btn?.addEventListener('click', () => {
  const ex = btn.getAttribute('aria-expanded') === 'true'
  btn.setAttribute('aria-expanded', String(!ex))
  btn.setAttribute('aria-label', ex ? 'Open menu' : 'Close menu')
  if (st) st.textContent = 'State: ' + (ex ? 'menu' : 'close')
})`,
}

export default preset
